// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  programVolets: path(ROOTS_DASHBOARD, '/programandvolets'),
  one: path(ROOTS_DASHBOARD, '/one'),
  two: path(ROOTS_DASHBOARD, '/two'),
  three: path(ROOTS_DASHBOARD, '/three'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    programVolets: path(ROOTS_DASHBOARD, '/programandvolets'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  activity: {
    root: path(ROOTS_DASHBOARD, '/activity/list'),
  },
  history: {
    root: path(ROOTS_DASHBOARD, '/history/list'),
  },
  charts: {
    root: path(ROOTS_DASHBOARD, '/charts/list'),
  },
  indicators: {
    root: path(ROOTS_DASHBOARD, '/indicators/list'),
  },
  carbon: {
    root: path(ROOTS_DASHBOARD, '/carbon/list'),
  },
  carbonStats: {
    root: path(ROOTS_DASHBOARD, '/carbonStats/list'),
  },
  folder: {
    root: path(ROOTS_DASHBOARD, '/folder'),
    new: path(ROOTS_DASHBOARD, '/folder/new'),
    list: path(ROOTS_DASHBOARD, '/folder/list'),
    // fileId: (id: string) => path(ROOTS_DASHBOARD, `/folder/indicator/${id}`),
    listId: (name: string) => path(ROOTS_DASHBOARD, `/folder/${name}`),
    cards: path(ROOTS_DASHBOARD, '/folder/cards'),
    profile: path(ROOTS_DASHBOARD, '/folder/profile'),

    edit: (name: string) => path(ROOTS_DASHBOARD, `/folder/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/folder/reece-chung/edit`),
  },
};
